<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoDetalhar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoDetalhar">
			<form>
				<div class="formgroup">
					<div class="flex justify-content-center mt-3" *ngIf="loading">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid pt-3 px-3" *ngIf="fornecedor">
						<div class="col-12 card-simple mb-5">
							<div class="p-fluid p-formgrid grid">
								<div class="col-12 md:col-4">
									<label class="label-superior">Nome Fonecedor</label>
									<label class="label-inferior" id="nomeFornecedor">{{ fornecedor.nomeFornecedor }}</label>
								</div>
		
								<div class="col-12 md:col-4">
									<label class="label-superior">Razão Social</label>
									<label class="label-inferior" id="razaoSocial">{{ fornecedor.razaoSocial }}</label>
								</div>
								<div class="col-12 md:col-4">
									<label class="label-superior">CNPJ</label>
									<label class="label-inferior" id="razaoSocial">
										{{ fornecedor.cnpj | cnpjFormat }}
									</label>
								</div>
		
								<div class="col-12 md:col-4">
									<label class="label-superior">Nome Contato</label>
									<label class="label-inferior" id="nomeContato">{{ fornecedor.nomeContato }}</label>
								</div>
								
								<div class="col-12 md:col-4">
									<label class="label-superior">Fone Contato</label>
									<label class="label-inferior" id="foneContato">{{ fornecedor.foneContato }}</label>
								</div>
								<div class="col-12 md:col-3">
									<label class="label-superior">Cidade</label>
									<label class="label-inferior" id="cidade">{{ fornecedor.cidade }}</label>
								</div>
		
								<div class="col-12 md:col-1">
									<label class="label-superior">UF</label>
									<label class="label-inferior" id="uf">{{ fornecedor.uf }}</label>
								</div>
							</div>
						</div>

					</div>

					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loading">
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button"  pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/fornecedor"></button>
						</div>
					</div>

				</div>
			</form>
		</div>
	</div>
</div>